import Vue from 'vue'
import App from './App.vue'
import Spinner from './components/shared/Spinner'
import router from './router'
import { store } from './store'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import Carousel3d from 'vue-carousel-3d';
import vuetify from './plugins/vuetify'
import './assets/css/normalize.css'
import './assets/css/main.css'
import './assets/css/utilities/extra-styles-bootstrap.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBars, faPowerOff, faHome, faSms, faHistory, faUserCircle, faInfoCircle,
  faFileSignature, faFlag, faFlagCheckered, faGlobe, faChevronLeft, faCaretLeft,
  faArrowLeft, faAngleLeft, faChevronCircleLeft, faCaretSquareLeft, faArrowCircleLeft,
  faAngleDoubleLeft, faLongArrowAltLeft, faChevronRight, faCaretRight, faArrowRight,
  faAngleRight, faChevronCircleRight, faCaretSquareRight, faArrowCircleRight,
  faAngleDoubleRight, faLongArrowAltRight, faDatabase, faMoneyBillAlt, faFileInvoice,
  faFileInvoiceDollar, faDotCircle, faTimes, faStar as fasStar, faSpinner,
  faSync, faSyncAlt, faCheck, faCheckCircle, faCheckDouble, faCheckSquare, faUsers,
  faPen, faTrash, faEye, faPlus, faFileAlt, faTags, faDollarSign, faTimesCircle, faAt
} from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
import { faWhatsapp, faWhatsappSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faBars, faPowerOff, faHome, faSms, faHistory, faUserCircle, faInfoCircle,
  faFileSignature, faFlag, faFlagCheckered, faGlobe, faChevronLeft,
  faCaretLeft, faArrowLeft, faAngleLeft, faChevronCircleLeft,
  faCaretSquareLeft, faArrowCircleLeft, faAngleDoubleLeft,
  faLongArrowAltLeft, faChevronRight, faCaretRight, faArrowRight,
  faAngleRight, faChevronCircleRight, faCaretSquareRight,
  faArrowCircleRight, faAngleDoubleRight, faLongArrowAltRight, faDatabase,
  faMoneyBillAlt, faFileInvoice, faFileInvoiceDollar, faDotCircle,
  faTimes, fasStar, farStar, faSpinner, faSync, faSyncAlt, faCheck,
  faCheckCircle, faCheckDouble, faCheckSquare, faWhatsapp, faWhatsappSquare,
  faUsers, faPen, faTrash, faEye, faPlus, faFileAlt, faTags, faDollarSign, faTimesCircle, faAt
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuelidate);
Vue.use(Carousel3d);

Vue.filter('capitalizeWord',  value => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() )
Vue.filter('two_digits',  value => {
  if (value < 0) return '00';
  if (value.toString().length <= 1) return `0${value}`
  return value;
})
Vue.component('AppSpinner', Spinner)

Vue.config.productionTip = false;

// Defining some axios constant parameters that won't change in any request
// axios.defaults.baseURL = store.getters.getBaseURL + 'crud/';
axios.defaults.headers.common = {
  // 'Access-Control-Allow-Origin': 'https://api.smsfactor.com',
  'Content-Type': 'application/json'
};

new Vue({
  el: '#app',
  store,
  router,
  vuetify,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js